import React from "react";
import { useNavigate } from "react-router-dom";
import { apolloClient } from "data/graphql";
import { wipeToken } from "utils/general-utils";
import { clearPageNumbers } from "./dashboard/interests/utils";

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const logout = () => {
    clearPageNumbers();
    wipeToken();
    apolloClient.resetStore(); // Clear + refetch
    apolloClient.cache.gc();
    navigate("/login", { replace: true });
  };
  React.useEffect(logout, []);

  return null;
};

export default Logout;
